import { ValidationErrors, AsyncValidatorFn, AbstractControl } from "@angular/forms";
import { Observable, timer, of } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { ItemQuery } from 'web-shared';
import {ManufacturingItemModel} from "web-shared";

export function uniqueCodeValidator(alltems$: Observable<ItemQuery[]>, item: ManufacturingItemModel): AsyncValidatorFn {
    return (control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
        return timer(200).pipe(switchMap(() => {
            return alltems$.pipe(
                    map(items => items.filter(i => i.Id != item.Id && i.Code === control.value)),
                    switchMap(items => items.length > 0 ? of({ 'codeNotUnique': true }) : of(null))
                )
        }))
    };
}
